export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Is there a total network outage in a factory?',
      $formkit: 'radio',
      help: 'i.e. impact on operation',
      if: '$incidentForms.type === OfficeIt',
      name: 'officeTotalNetworkOutageFactory',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Is there a total network outage impacting multiple people?',
      $formkit: 'radio',
      help: 'Internet connection at HH or Manchester and VPN access for those working off-site (i.e. AnyConnect)',
      if: '$incidentForms.officeTotalNetworkOutageFactory === no',
      name: 'officeTotalNetworkOutage',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Total unavailability or significant degradation in performance of core office technologies?',
      $formkit: 'radio',
      help: 'i.e. GSuite, Google Meet, Slack, Jira, Confluence, Snowflake, GitHub, OKTA',
      if: '$incidentForms.officeTotalNetworkOutage === no',
      name: 'officeCoreTech',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Total unavailability or significant degradation in performance of non-core office technologies?',
      $formkit: 'radio',
      help: 'i.e. Microsoft O365, Microsoft Project, Adobe Creative Cloud, Zoom, PagerDuty, SolarWinds',
      if: '$incidentForms.officeCoreTech === no',
      name: 'officeNonCoreTech',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      $el: 'div',
      if: '$incidentForms.officeNonCoreTech === no',
      children: [
        {
          $el: 'section',
          attrs: {
            class: 'incident-details',
          },
          children: [
            {
              $el: 'h3',
              children: 'We believe that this is a low severity incident.',
            },
            {
              $el: 'p',
              children: 'Contact the Tech Bar for help.',
            },
          ],
        },
      ],
    },
  ],
}
